<template>
  <div v-if="user">
    <div class="chain-user-index" v-if="user.chain_state==1">
      <div class="user-header">
        <div class="info-wrapper">
            <div><span class="user-name">{{user.chain_addressname}}</span></div>
            <div class="div phone-wrapper">
				<img class="img" src="../../../assets/image/chain/location.png">
				<span class="user-phone">{{user.chain_address}}</span>
			</div>
		</div>
		<span class="span iconfont btn-exit" @click="logout">&#xe688;</span>
      </div>
      <div class="chain-menu">
        <div @click="$router.push({name:'ChainOrderList'})">
        <flex-line class="menu-item"
                 :is-link="true" :show-border="true">
          <div>
          <span>订单管理</span>
          </div>
        </flex-line>
        </div>
        <div @click="$router.push({name:'ChainGoodsList'})">
        <flex-line v-if="info.store_id" class="menu-item"
                 :is-link="true" :show-border="true">
          <div>
          <span>库存管理</span>
          </div>
        </flex-line>
        </div>
        <div @click="$router.push({name:'ChainSetting'})">
          <flex-line class="menu-item"
                   :is-link="true" :show-border="true">
            <div>
            <span>门店设置</span>
            </div>
          </flex-line>
        </div>
        <div @click="showPassword=true">
          <flex-line class="menu-item"
                   :is-link="true" :show-border="true">
            <div>
            <span>修改密码</span>
            </div>
          </flex-line>
        </div>
      </div>
      <mt-popup v-model="showPassword" position="right" class="common-popup-wrapper">
        <div class="common-header-wrap">
          <mt-header title="修改密码" class="common-header">
            <mt-button slot="left" icon="back" @click="showPassword=false"></mt-button>
          </mt-header>
        </div>
        <div class="common-popup-content">
          <div class="main-content">
          <flex-line class="field-line" :show-border="true"><span class="field-name">原密码</span><div class="field-line-right" slot="right"><input class="field-input" type="password" v-model="passowrdData.old_password" /></div></flex-line>
          <flex-line class="field-line" :show-border="true"><span class="field-name">新密码</span><div class="field-line-right" slot="right"><input class="field-input" type="password" v-model="passowrdData.password" /></div></flex-line>
          <flex-line class="field-line" :show-border="true"><span class="field-name">确认密码</span><div class="field-line-right" slot="right"><input class="field-input" type="password" v-model="passowrdData.passwd_confirm" /></div></flex-line>
          <div class="common-btn ds-button-large mt-10"  @click="submit">提交</div>
          </div>
        </div>
      </mt-popup>
    </div>
    <div v-else>
      <div class="common-header-wrap">
        <mt-header title="代收点加盟" class="common-header">
          <mt-button slot="left" icon="back" @click="$router.go(-1)"></mt-button>
        </mt-header>
      </div>
      <div class="wait-wrapper">
        <img class="wait-img" src="../../../assets/image/wait_verify.png" />
        <div class="message" v-if="user.chain_state==10">
          请等待管理员审核
        </div>

        <div class="message" v-if="user.chain_state==0">
          代收点已关闭
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Toast } from 'mint-ui'
import { mapState, mapMutations } from 'vuex'
import { chainLogout, chainChangePassword, chainInformation } from '../../../api/chainManage'
import flexLine from '../../flexLine'
export default {
  name: 'ChainUser',
  data () {
    return {
      showSetting: false,
      showPassword: false,
      passowrdData: {},
      info:{}
    }
  },
  components:{
    flexLine
  },
  created: function () {
    if (!this.user) {
      this.$router.push({ name: 'ChainLogin' })
    } else {
      // if (this.user.invalid_time < parseInt((new Date().getTime()) / 1000)) { // 重新拉取信息
      chainInformation().then(res => {
        let info = res.result.chain_info
        this.info=info
        this.chainUpdate({ info: res.result.info })
        if (info.chain_state == 20) {
          Toast('审核不通过：' + info.chain_failreason)
          this.$router.push({ name: 'ChainRegister' })
        }
      }).catch(function (error) {
        Toast(error.message)
      })
      // }
    }
  },
  methods: {
    ...mapMutations({
      chainUpdate: 'chainUpdate',
      chainLogout: 'chainLogout'
    }),
    submit () {
      chainChangePassword(this.passowrdData).then(res => {
        Toast(res.message)
        this.showPassword = false
      }).catch(function (error) {
        Toast(error.message)
      })
    },
    logout () {
      chainLogout().then(res => {
        this.chainLogout()
        this.$router.push({ name: 'ChainLogin' })
      }).catch(function (error) {
        Toast(error.message)
      })
    }
  },
  computed: {
    ...mapState({
      user: state => state.chain.info,
      token: state => state.member.token
    })
  }

}
</script>
<style  lang="scss" scoped>
.main-content{background: #fff;padding:0 $pageSpace}
  .chain-user-index{
    .user-header{
    		position: relative;
    		background: url("../../../assets/image/chain/background.png") no-repeat;
    		background-size: cover;
    		height: 11rem;
    		display: flex;
    		justify-content: center;
    		align-items: center;
    		color:#fff;
    		font-size:$h2;
    		.info-wrapper{
    			padding:1rem .5rem;
    			text-align: center;
    			.user-name{
    				font-size:1.2rem;
    			}
    			.phone-wrapper{
    				display: flex;
    				align-items: center;
    				margin-top: .5rem;
    				.img{
    					width: .9rem;
    					height: .9rem;
    					margin-right: .3rem;
    				}
    				.user-phone{
    					font-size:.8rem;
    					opacity:.8;
    				}
    			}
    			
    			.btn-exit{float:right;font-size:$h1;opacity: .8;}
    		}
    		.iconfont{
    			position: absolute;
    			top: 1rem;
    			right: 1rem;
    			font-size: 1rem;
    		}
    }
    .chain-menu{background:#fff;padding:0 $pageSpace;margin-top:$modelSpace;
      .menu-item{border-bottom:1px solid #eee;
        &::after{background: none}
        .left-icon{font-size:$h1;}
      }
    }
  }
  .wait-wrapper{margin-top:5rem;text-align: center}
  .wait-wrapper .wait-img{width:13rem;}
  .wait-wrapper .message{font-size:$subFontSize;}
</style>
